import * as types from './types';
import { setLoading } from '../../../../common/actions';
import Api from '../../../../../lib/api';

export const setError = (error) => {
  return {
    type: types.SET_FINANCIALS_ERROR,
    error
  };
};

export const setSuccessMsg = (successMsg) => {
  return {
    type: types.SET_FINANCIALS_SUCCESS_MSG,
    successMsg
  };
};

/* SCORE CARDS */
export const setFetchingAccountsList = (isFetching) => {
  return {
    type: types.SET_FETCHING_ACCOUNTS_LIST,
    isFetching
  };
};

export const setFetchingcalculateAccounts = (isFetching) => {
  return {
    type: types.SET_FETCHING_CALCULATE_ACCOUNTS,
    isFetching
  };
};

export const setEmptyAccountsList = () => {
  return {
    type: types.SET_ACCOUNTS_LIST,
    accountsList: [],
    basicAccounts: { accounts: [] },
    accountsListData: {},
    scorecardSourcePossibleValues: [],
    scorecardCompaniesTypesPossibleValues: [],
    scorecardTurnOverRatesPossibleValues: [],
    referencesPossibleValues: [],
    legalPossibleValues: [],
    creditHistoryPossibleValues: [],
    scorecardConcetpsList: [],
    avgProjectAccounts: [],
    avgVolumeAccounts: [],
    subcontractorData: {},
    bankLinePossibleValues: [],
    analysisTypePossibleValues: [],
    financialStatementTypePossibleValues: [],
    companiesTypesPossibleValues: [],
    discreteAccounts: [],
  };
}

export const setAccountsList = (data) => {
  return {
    type: types.SET_ACCOUNTS_LIST,
    accountsList: data.accountsList,
    basicAccounts: data.basicAccounts,
    accountsListData: data.subcontractorData,
    scorecardSourcePossibleValues: data.scorecardSourcePossibleValues,
    scorecardCompaniesTypesPossibleValues: data.scorecardCompaniesTypesPossibleValues,
    scorecardTurnOverRatesPossibleValues: data.scorecardTurnOverRatesPossibleValues,
    referencesPossibleValues: data.referencesPossibleValues,
    legalPossibleValues: data.legalPossibleValues,
    creditHistoryPossibleValues: data.creditHistoryPossibleValues,
    scorecardConcetpsList: data.scorecardConcetpsList,
    avgProjectAccounts: data.avgProjectAccounts,
    avgVolumeAccounts: data.avgVolumeAccounts,
    subcontractorData: data.subcontractorData,
    bankLinePossibleValues: data.bankLinePossibleValues,
    analysisTypePossibleValues: data.analysisTypePossibleValues,
    financialStatementTypePossibleValues: data.financialStatementTypePossibleValues,
    companiesTypesPossibleValues: data.companiesTypesPossibleValues,
    discreteAccounts: data.discreteAccounts,
    accountDisplayTypeId: data.accountDisplayTypeId,
  };
};

export const setCalculatedAccounts = (data) => {
  return {
    type: types.SET_CALCULATED_ACCOUNTS,
    data
  };
};

export const setWorkingCapital = (data) => {
  return {
    type: types.SET_WORKING_CAPITAL,
    data
  };
};

export const setSubmitionDates = (data) => {
  return {
    type: types.SET_SUBMITION_DATES,
    data
  };
};

export const setPrequalDates = (data) => {
  return {
    type: types.SET_PREQUAL_DATES,
    data
  };
};

export const setSavedFormAsCompleted = () => {
  return {
    type: types.SET_SAVED_FORM_AS_COMPLETED
  };
};

export const fetchAccountsList = (hcId, scId, savedFormId, origin) => {
  return (dispatch, getState) => {
    const token = getState().login.authToken;
    dispatch(setFetchingAccountsList(true));
    dispatch(fetchPrequalDates(hcId, scId));

    let url = '';

    if (savedFormId && (!hcId || !scId)) {
      url = `finances/scorecards?savedFormId=${savedFormId}`;
    } else {
      url = `finances/scorecards?hcId=${hcId}&scId=${scId}&savedFormId=${savedFormId}`;
    }

    return Api.get(
      url,
      token,
    ).then(response => {
      const { success, data } = response.data;
      // console.log(response.data);
      if (success && data) {

        const accountListData = {
          accountsList: data.accountsList,
          basicAccounts: data.basicAccounts,
          accountsListData: data.subcontractorData,
          scorecardSourcePossibleValues: data.scorecardSourcePossibleValues,
          scorecardCompaniesTypesPossibleValues: data.scorecardCompaniesTypesPossibleValues,
          scorecardTurnOverRatesPossibleValues: data.scorecardTurnOverRatesPossibleValues,
          referencesPossibleValues: data.referencesPossibleValues,
          legalPossibleValues: data.legalPossibleValues,
          creditHistoryPossibleValues: data.creditHistoryPossibleValues,
          scorecardConcetpsList: data.scorecardConcetpsList,
          avgProjectAccounts: data.avgProjectAccounts,
          avgVolumeAccounts: data.avgVolumeAccounts,
          subcontractorData: data.subcontractorData,
          bankLinePossibleValues: data.bankLinePossibleValues,
          analysisTypePossibleValues: data.analysisTypePossibleValues,
          financialStatementTypePossibleValues: data.financialStatementTypesPossibleValues,
          companiesTypesPossibleValues: data.companiesTypesPossibleValues,
          discreteAccounts: data.discreteAccountsList,
          accountDisplayTypeId: data.accountDisplayTypeId,
        };

        dispatch(setAccountsList(accountListData));
      }
      dispatch(setFetchingAccountsList(false));
    }).catch(error => {
    //console.log(error);
    });
  };
}

export const fetchSubmissionDates = (hcId, scId, origin) => {
  return (dispatch, getState) => {
    const token = getState().login.authToken;
    return Api.get(
      `forms/savedforms/datessubmission?subcontractorId=${scId}&hiringClientId=${hcId}`,
      token
    ).then(response => {
      const { success, data } = response.data;
      if (success) {
        dispatch(setSubmitionDates(data));
      }
    })
      .catch(error => {
      //console.log(error);
      });
  };
}

export const fetchPrequalDates = (hcId, scId) => {
  return (dispatch, getState) => {
    const token = getState().login.authToken;
    return Api.get(
      `forms/savedforms/datesprequal?subcontractorId=${scId}&hiringClientId=${hcId}`,
      token
    ).then(response => {
      const { success, data } = response.data;
      if (success) {
        dispatch(setPrequalDates(data));
      }
    })
      .catch(error => {
      //console.log(error);
      });
  };
}

export const saveAccountsList = (payload, callback) => async (dispatch, getState) => {
  const token = getState().login.authToken;
  dispatch(setFetchingAccountsList(true));
  dispatch(setError(null));
  try {
    const response = await Api.post(`finances/scorecards`, payload, token);
    const { success } = response.data;
    if (success) {
      dispatch(setSuccessMsg("Changes successfully saved"));
      if (callback) {
        callback(true);
      }
    } else {
      throw new Error("Error while saving");
    }
  } catch (error) {
    //console.log(error)
    dispatch(setError("There was an error while saving, please try again"));
    if (callback) {
      callback(false);
    }
  } finally {
    dispatch(setFetchingAccountsList(false));
  }
};


export const fetchWorkingCapital = (payload) => {
  return (dispatch, getState) => {
    const token = getState().login.authToken;
    dispatch(setFetchingcalculateAccounts(true));
    dispatch(setError(null));
    return Api.post(
      `finances/workingCapital`,
      payload,
      token
    ).then(response => {
      const { success, workingCapital } = response.data;
      if (success) {
        // console.log('fetchWorkingCapital response.data = ', response.data)
        dispatch(setWorkingCapital(workingCapital));
      } else {
      //console.log(response.data)
        dispatch(setError("There was an error, please try again"));
      }
      dispatch(setFetchingcalculateAccounts(false));
    })
      .catch(error => {
      //console.log(error);
        dispatch(setError("There was an error, please try again"));
        dispatch(setFetchingcalculateAccounts(false));
      });
  };
}

export const fetchCalculatedAccounts = (payload, callback) => {
  return (dispatch, getState) => {
    const token = getState().login.authToken;
    dispatch(setFetchingcalculateAccounts(true));
    dispatch(setError(null));
    return Api.post(
      `finances/scorecards`,
      payload,
      token
    ).then(response => {
      const { success, calcRes } = response.data;
      if (success) {
        // console.log('fetchCalculatedAccounts response.data = ', response.data)
        dispatch(setCalculatedAccounts(calcRes));
      } else {
        dispatch(setError("There was an error, please try again"));
      }
      dispatch(setFetchingcalculateAccounts(false));
      if (typeof callback == 'function') {
        callback(true)
      }
    })
      .catch(error => {
      //console.log(error);
        dispatch(setError("There was an error, please try again"));
        dispatch(setFetchingcalculateAccounts(false));
        if (typeof callback == 'function') {
          callback(error)
        }
      });
  };
}

/* SCORE CARDS CONCEPTS */
export const setFetchingScoreCardsConcepts = (isFetching) => {
  return {
    type: types.SET_FETCHING_SCORE_CARDS_CONCEPTS,
    isFetching
  };
};
export const setScoreCardsConceptsEmpty = () => {
  return {
    type: types.SET_SCORE_CARDS_CONCEPTS,
    scoreCardsConcepts: [],
    subcontractorData: {},
    scorecardMainParameters: {},
    discreteAccountsList: [],
    accountDisplayTypeId: 1,
    commentary: null,
    averageConcepts: {
      avgProjectAccounts: [],
      avgVolumeAccounts: []
    },
    emrAccounts: [],
    isScoreCardEmpty: true,
    scorecardHiddenFields: [],
    isCovid19Form: false,
    basicAccounts: [],
  };
};
export const setScoreCardsConcepts = (data) => {
  return {
    type: types.SET_SCORE_CARDS_CONCEPTS,
    averageConcepts: {
      avgProjectAccounts: data.avgProjectAccounts,
      avgVolumeAccounts: data.avgVolumeAccounts
    },
    accountDisplayTypeId: data.accountDisplayTypeId,
    discreteAccountsList: data.discreteAccountsList,
    commentary: data.commentary,
    emrAccounts: data.emrAccounts,
    nevadaSingleLimit: data.nevadaSingleLimit,
    scoreCardsConcepts: data.scorecardConcepts,
    subcontractorData: data.subcontractorData,
    scorecardMainParameters: data.scorecardMainParameters,
    isScoreCardEmpty: false,
    scorecardHiddenFields: data.scorecardHiddenFields,
    isCovid19Form: data.isCovid19Form,
    basicAccounts: data.basicAccounts,
  };
};
export const fetchScoreCardsConcepts = (savedFormId) => {
  // console.log('>>>fetchScoreCardsConcepts, savedFormId = ', savedFormId)
  return (dispatch, getState) => {
    const token = getState().login.authToken;
    dispatch(setFetchingScoreCardsConcepts(true));
    return Api.get(
      `finances/scorecardsconcepts?savedFormId=${savedFormId}`,
      token
    ).then(response => {
      const { success, data } = response.data;

      if (success && data) {
        dispatch(setScoreCardsConcepts(data));
      } else {
        dispatch(setScoreCardsConceptsEmpty());
      }
      dispatch(setFetchingScoreCardsConcepts(false));
    })
      .catch(error => {
      //console.log(error);
        dispatch(setScoreCardsConcepts([]));
        dispatch(setFetchingScoreCardsConcepts(false));
      });
  };
}

export const fetchEmbeddedReportsInfo = (params) => {
  return (dispatch, getState) => {
    const token = getState().login.authToken;
    return Api.post(
      `EmbeddedReportsInfo`,
      params,
      token
    ).then(response => {
      const { success, results } = response.data;
      // console.log('fetchEmbeddedReportsInfo response.data = ', response.data)
      if (success) {
        return results
      }
    })
      .catch(error => {
      //console.log(error);
      });
  };
}

// Fetch mark financial form as incompleted
export const markFinancialInfoAsIncompleted = (payload, callback) => {
  return (dispatch, getState) => {
    const { login: { authToken }} = getState();

    dispatch(setLoading(true));

    return Api.put('finances/markAsIncompleted', payload, authToken)
    .then(response => {
      const { success } = response.data;

      if (success) {
        dispatch(setLoading(false));
        if (callback) callback(true);
      } else {
        dispatch(setLoading(false))
        if (callback) callback(false);
      }
    }).catch((e) => {
    //console.log(e)
      dispatch(setLoading(false));
      if (callback) callback(false);
    });
  };
};

export const force = (payload, callback) => {
  return (dispatch, getState) => {
    const { login: { authToken }} = getState();

    dispatch(setLoading(true));

    return Api.put('finances/force', payload, authToken)
    .then(response => {
      const { success } = response.data;
      if (success) {
        dispatch(setLoading(false));
        if (callback) callback(response.data);
      } else {
        dispatch(setLoading(false))
        if (callback) callback(response.data);
      }
    }).catch((e) => {
      dispatch(setLoading(false));
      if (callback) callback(false);
    });
  };
};

// Fetch Copy Submission modal submit
export const setCopyFinancialSubmissionFetching = () => {
  return {
    type: types.SET_COPY_FINANCIAL_SUBMISSION_FETCHING,
  };
};

export const setCopyFinancialSubmissionSuccess = () => {
  return {
    type: types.SET_COPY_FINANCIAL_SUBMISSION_SUCCESS,
  };
};

export const setCopyFinancialSubmissionError = (error) => {
  return {
    type: types.SET_COPY_FINANCIAL_SUBMISSION_ERROR,
    error,
  };
};

export const copyFinancialSubmission = (payload, callback) => {
  return (dispatch, getState) => {
    const { login: { authToken }, localization } = getState();

    const {
      error10005,
      error10006,
      error10007,
      error10011,
      error10019,
      errorDefault,
      errorConnection,
    } = localization.strings.subcontractors.actions;

    dispatch(setCopyFinancialSubmissionFetching());

    return Api.post('finances/copyFinancialInfoSubmission', payload, authToken)
    .then(response => {
      const { success, data } = response.data;

      let errorMsg = '';

      if (success) {
        setTimeout(() => {
          dispatch(setCopyFinancialSubmissionSuccess());
          if (callback) callback(true);   
        }, 5000);
      } else {
        switch(data.errorCode) {
          case 10005:
            errorMsg = error10005;
          break;
          case 10006:
            errorMsg = error10006;
            break;
          case 10007:
            errorMsg = error10007;
            break;
          case 10011:
            errorMsg = error10011;
            break;
          case 10019:
            errorMsg = error10019;
            break;
          default:
            errorMsg = errorDefault;
            break;
        }

        dispatch(setCopyFinancialSubmissionError(errorMsg));
        if (callback) callback(false);
      }
    }).catch((e) => {
    //console.log(e)
      dispatch(setCopyFinancialSubmissionError(errorConnection));
      if (callback) callback(false);
    })
  };
};
